<!-- svelte-ignore a11y-missing-content -->
<!-- svelte-ignore a11y-missing-attribute -->

<script context="module">
	// these are every sections defaults
	export const defaults = {
		"style": {
			"padding": "7px 15px",
			"text-align": "left",
			"font-size": "inherit"
		}, 
		"insetStyle": {
			"padding": "7px 10px"
		}, 
		"cardStyle": {
			"display": "flex",
			"flex-direction": "column",
			"align-items": "inherit"
		}
		
	}


</script>

<script>

	import { onMount, onDestroy } from 'svelte';
    import { State } from '../store.js';
	import { v4 as uuidv4 } from 'uuid';
	import { addInspectable } from '../inspectable';
	import { tick } from 'svelte';
	
	export let index = null;
	export let name = "Section"
	export let userSettings = {}
	export let type = null;
	export let active = false;


	$: active = $State.activeElementId == $State.components[index].id
	$: isFooter = $State.components[index].type == "fixedFooter"
	$: footerHasChildren = isFooter && $State.components.length > index + 1

	export let sectionContainer = null

	const unsubscribe = State.subscribe(async (v) => {
		await tick();
		if (sectionContainer !== null) {
			sectionContainer.querySelectorAll("[data-i-name]").forEach((element) => {
				addInspectable(element, userSettings, $State.live)
			})
		}
	})


	onDestroy(unsubscribe);

</script>


{#if $State.previewMode}
<!-- 
<div style="display: flex; justify-content: center; align-items: center; padding: 20px 0px;" class="preview-title {$State.previewMode ? 'preview-mode' : ''}">
    <hr><p style="text-align: center; white-space: nowrap; padding: 0px 10px; text-transform: uppercase; opacity: 0.5; letter-spacing: 0.15rem; font-size: 0.7rem; display: flex; justify-content: center; align-items: center;">{name}</p><hr>
</div> -->

{/if}



<div class:is-footer={isFooter} class:has-children={footerHasChildren} bind:this={sectionContainer}  class="section {($State.previewMode && !$State.live) ? 'preview-mode' : ''}" class:active={active}>
	<div data-i-name="outer-container" class="container">
		<div data-i-name="inner-container" class="card"> 
			<svelte:component this={type}/>
		</div>
	</div>
</div>



<style>
	
	.section {
		/* border: 2px solid rgba(0,0,0,0); */
		display: flex;
		align-items: stretch;
		justify-content: stretch;
	}

	.container {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: stretch;
		width: 100%;
	}

	.section.preview-mode:hover {
		outline: 2px solid rgba(var(--selection-color-rgb), 0.9);
		box-shadow: rgba(var(--selection-color-rgb), 0.1) 0px 0px 1px 4px inset;
		background-color: rgba(var(--selection-color-rgb), 0.04);
		cursor: pointer;
	}

	.section.preview-mode.active {
		outline: 2px solid rgba(var(--selection-color-rgb), 0.9);
		box-shadow: rgba(var(--selection-color-rgb), 0.1) 0px 0px 1px 4px inset;
		background-color: rgba(var(--selection-color-rgb), 0.04);
		z-index: 1000;
	}

	.section.is-footer.preview-mode:hover {
		outline: 0px solid rgba(var(--selection-color-rgb), 0.9);
		box-shadow: none;
		background-color: unset;
		cursor: unset;
	}


	.section.is-footer.preview-mode.active {
		outline: 0px solid rgba(var(--selection-color-rgb), 0.9);
		box-shadow: rgba(var(--selection-color-rgb), 0.1) 0px 0px 1px 4px inset;
		background-color: rgba(var(--selection-color-rgb), 0.04);
		z-index: 1000;
	}

</style>